<template>
    <div class="contact">
        <div v-if="(($store.state.service&&$store.state.service!='')&&showContact)">
            <div @mouseleave="handlePhone(false)" @mouseenter="handlePhone(true)" class="tel" v-if="showPhone">
                <div class="inbox">{{ $store.state.service }}</div>
            </div>
            <img @mouseleave="handlePhone(false)" @mouseenter="handlePhone(true)" v-else class="phone-box"
                src="../assets/contactPhone.png" alt="">
        </div>
        <el-backtop :target="target" :bottom="260" :right="30">
            <div>
                <img class="top-box" src="../assets/goTop.png" alt="">
            </div>
        </el-backtop>

    </div>

</template>
<script>
export default {
    props: {
        target: {
            type: String,
            default: () => { }
        },
        showContact:{
            type:Boolean,
            default:()=>{}
        }
    },
    data() {
        return {
            showPhone: false
        }
    },
    methods: {
        handlePhone(e) {
            this.showPhone = e
        }
    }
}
</script>
<style scoped lang="scss">
.contact {
    position: fixed;
    bottom: 300px;
    right: 0;
    display: flex;
    flex-direction: column;
    align-items: end;
    cursor: pointer;

    /deep/.el-backtop {
        width: 0;
        height: 0;
    }

    .phone-box {
        width: 70px;
        height: 70px;
    }

    .top-box {
        width: 58px;
        height: 58px;
        margin-top: 20px;
    }

    .tel {
        width: 150px;
        height: 70px;
        border: 1px solid #409eff;

        .inbox {
            width: 148px;
            height: 68px;
            line-height: 68px;
            text-align: center;
            background-color: #409eff;
            border: 1px solid #fff;
            color: #fff;
        }
    }
}
</style>